/**
 * Coolwindshades Product Customizer v7
 * Features: tooltip previews, dimension gate, cart modal, dynamic pricing, description links
 */
(function() {
  'use strict';

  var C = {
    basePrice: 0,
    sel: {},
    qty: 1,
    booting: true,
    gated: ['power_type','motor_type','valance_type','bottom_rod','motor_side','remote_type','solar_panel','usb_charger','light_blockers'],

    init: function() {
      try {
        var wrap = document.querySelector('.customizer-wrapper');
        if (!wrap) return;
        this.basePrice = parseFloat(wrap.dataset.basePrice) || 0;
        this.bindCards();
        this.bindMeasurement();
        this.bindWarranty();
        this.bindQuantity();
        this.bindAddToCart();
        this.bindModal();
        this.bindHoverPreview();
        this.fixDescriptionLinks();
        this.labelDropdownPrices();
        this.setDefaults();
        this.booting = false;
        this.updatePrice();
      } catch(e) { console.error('Init error:', e); }
    },

    labelDropdownPrices: function() {
      try {
        var tableEl = document.getElementById('cw-price-tables');
        if (!tableEl) return;
        var tables = JSON.parse(tableEl.textContent);
        var wSel = document.getElementById('cw-width-int');
        var hSel = document.getElementById('cw-height-int');
        if (wSel && tables.width) {
          for (var i = 1; i < wSel.options.length; i++) {
            var v = wSel.options[i].value, p = tables.width[v];
            if (p > 0) wSel.options[i].textContent = v + '"  (+$' + p + ')';
          }
        }
        if (hSel && tables.height) {
          for (var j = 1; j < hSel.options.length; j++) {
            var v2 = hSel.options[j].value, p2 = tables.height[v2];
            if (p2 > 0) hSel.options[j].textContent = v2 + '"  (+$' + p2 + ')';
          }
        }
      } catch(e) {}
    },

    fixDescriptionLinks: function() {
      try {
        document.querySelectorAll('.customizer-module__description a').forEach(function(a) {
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener noreferrer');
        });
      } catch(e) {}
    },

    /* hover zoom removed — tooltip system handles previews */

    bindHoverPreview: function() {
      var cards = document.querySelectorAll('.option-card, .color-card');
      cards.forEach(function(card) {
        // Skip if card already has a tooltip (avoid double preview)
        if (card.querySelector('.option-card__tooltip')) return;
        var img = card.querySelector('.option-card__image, .color-card__swatch');
        if (!img || !img.src) return;
        var preview = document.createElement('div');
        preview.className = 'cw-hover-preview';
        var previewImg = document.createElement('img');
        previewImg.src = img.src;
        previewImg.alt = 'Preview';
        preview.appendChild(previewImg);
        card.appendChild(preview);
        card.addEventListener('mouseenter', function() {
          var rect = card.getBoundingClientRect();
          preview.classList.remove('cw-hover-preview--above', 'cw-hover-preview--below');
          if (rect.top > 340) {
            preview.classList.add('cw-hover-preview--above');
          } else {
            preview.classList.add('cw-hover-preview--below');
          }
        });
      });
    },

    bindModal: function() {
      var self = this;
      var closeBtn = document.getElementById('cw-modal-close');
      var backBtn = document.getElementById('cw-modal-back');
      var confirmBtn = document.getElementById('cw-modal-confirm');
      var overlay = document.getElementById('cw-cart-modal');
      if (closeBtn) closeBtn.addEventListener('click', function() { self.hideModal(); });
      if (backBtn) backBtn.addEventListener('click', function() { self.hideModal(); });
      if (overlay) overlay.addEventListener('click', function(e) { if (e.target === overlay) self.hideModal(); });
      if (confirmBtn) confirmBtn.addEventListener('click', function() { self.submitCart(); });
    },

    showModal: function(props) {
      var body = document.getElementById('cw-modal-body');
      var overlay = document.getElementById('cw-cart-modal');
      if (!body || !overlay) return;
      var html = '<table class="cw-modal__table">';
      var keys = Object.keys(props);
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].charAt(0) === '_') continue;
        html += '<tr><td class="cw-modal__key">' + keys[i] + '</td><td class="cw-modal__val">' + props[keys[i]] + '</td></tr>';
      }
      var priceEl = document.getElementById('cw-dynamic-price');
      if (priceEl) html += '<tr class="cw-modal__total"><td>Unit Price</td><td>' + priceEl.textContent + '</td></tr>';
      if (this.qty > 1 && priceEl) {
        var total = parseFloat(priceEl.textContent.replace('$','')) * this.qty;
        html += '<tr class="cw-modal__total"><td>Qty &times; ' + this.qty + ' Total</td><td>$' + total.toFixed(2) + '</td></tr>';
      }
      html += '</table>';
      body.innerHTML = html;
      overlay.style.display = 'flex';
    },

    hideModal: function() {
      var overlay = document.getElementById('cw-cart-modal');
      if (overlay) overlay.style.display = 'none';
    },

    isGated: function() {
      try {
        var w = document.getElementById('cw-width-int'), h = document.getElementById('cw-height-int'), cb = document.getElementById('cw-dimension-confirm');
        if (!w || !h || !cb) return false;
        if (!w.value || !h.value) return true;
        return !cb.checked;
      } catch(e) { return false; }
    },

    gateWarn: function() {
      try {
        var w = document.getElementById('cw-width-int'), h = document.getElementById('cw-height-int');
        var lbl = document.getElementById('cw-dimension-confirm-label'), errDiv = document.getElementById('cw-dimension-error');
        if (!w || !w.value || !h || !h.value) {
          if (w) { w.scrollIntoView({behavior:'smooth',block:'center'}); w.style.borderColor='#d32f2f'; setTimeout(function(){if(w)w.style.borderColor='';},2500); }
          return;
        }
        if (errDiv) errDiv.style.display = 'block';
        if (lbl) { lbl.style.display='flex'; lbl.classList.add('gate-highlight'); lbl.scrollIntoView({behavior:'smooth',block:'center'}); setTimeout(function(){if(lbl)lbl.classList.remove('gate-highlight');},2500); }
      } catch(e) {}
    },

    bindCards: function() {
      var self = this;
      document.querySelectorAll('.option-cards, .color-cards').forEach(function(container) {
        var mod = container.dataset.module;
        container.querySelectorAll('.option-card, .color-card').forEach(function(card) {
          card.addEventListener('click', function() {
            try {
              if (!self.booting && self.gated.indexOf(mod) !== -1 && self.isGated()) { self.gateWarn(); return; }
              container.querySelectorAll('.option-card, .color-card').forEach(function(c) { c.classList.remove('selected'); });
              card.classList.add('selected');
              self.sel[mod] = { label: card.dataset.label, price: parseFloat(card.dataset.price) || 0 };
              self.updatePrice();
            } catch(e) {}
          });
        });
      });
    },

    bindMeasurement: function() {
      var wI = document.getElementById('cw-width-int'), wF = document.getElementById('cw-width-frac');
      var hI = document.getElementById('cw-height-int'), hF = document.getElementById('cw-height-frac');
      var field = document.getElementById('cw-confirm-dimensions');
      var lbl = document.getElementById('cw-dimension-confirm-label');
      var cb = document.getElementById('cw-dimension-confirm');
      var errDiv = document.getElementById('cw-dimension-error');
      if (!wI || !wF || !hI || !hF) return;

      // Read price lookup tables from JSON
      var priceTables = { width: {}, height: {} };
      try {
        var tableEl = document.getElementById('cw-price-tables');
        if (tableEl) priceTables = JSON.parse(tableEl.textContent);
      } catch(e) { console.error('Price table parse error:', e); }

      var self = this;
      var isInitialRun = true;
      function update() {
        try {
          var wi=wI.value, wf=wF.value||'0', hi=hI.value, hf=hF.value||'0';
          if (wi && hi) {
            var ws = wf!=='0' ? wi+' '+wf : wi, hs = hf!=='0' ? hi+' '+hf : hi;
            if (field) field.value = ws+'"W x '+hs+'"H';
            if (lbl) lbl.style.display='flex';
            // Only reset checkbox on user-initiated changes, not on page load
            if (!isInitialRun) {
              if (cb) { cb.checked=false; if(lbl)lbl.classList.remove('confirmed'); }
            } else {
              // Restore confirmed state if checkbox is still checked (browser back)
              if (cb && cb.checked && lbl) lbl.classList.add('confirmed');
            }
            if (errDiv) errDiv.style.display='none';

            // Lookup width and height surcharges
            var widthPrice = priceTables.width[wi] || 0;
            var heightPrice = priceTables.height[hi] || 0;
            var sizePrice = widthPrice + heightPrice;

            self.sel['measurement'] = { label:field?field.value:'', width:wi, widthFraction:wf, height:hi, heightFraction:hf, sizePrice:sizePrice, widthPrice:widthPrice, heightPrice:heightPrice };
          } else {
            if (field) field.value=''; if (lbl) lbl.style.display='none'; delete self.sel['measurement'];
          }
          self.updatePrice();
        } catch(e) {}
      }
      [wI,wF,hI,hF].forEach(function(el) { el.addEventListener('change', update); });
      if (cb) cb.addEventListener('change', function() {
        try { if (cb.checked) { if(lbl)lbl.classList.add('confirmed'); if(errDiv)errDiv.style.display='none'; } else { if(lbl)lbl.classList.remove('confirmed'); } } catch(e) {}
      });
      // Initial update for browser-back pre-filled values
      if (wI.value || hI.value) update();
      isInitialRun = false;
    },

    bindWarranty: function() {
      var self = this;
      document.querySelectorAll('.warranty-option').forEach(function(opt) {
        opt.addEventListener('click', function() {
          try {
            if (!self.booting && self.isGated()) { self.gateWarn(); return; }
            var radio=opt.querySelector('input[type="radio"]'); if (radio) radio.checked=true;
            document.querySelectorAll('.warranty-option').forEach(function(o) { o.classList.remove('selected'); });
            opt.classList.add('selected');
            self.sel['warranty'] = { label:opt.dataset.label, price:parseFloat(opt.dataset.price)||0 };
            self.updatePrice();
          } catch(e) {}
        });
      });
    },

    bindQuantity: function() {
      var self=this, m=document.getElementById('cw-qty-minus'), p=document.getElementById('cw-qty-plus'), inp=document.getElementById('cw-qty-input');
      if (!m||!p||!inp) return;
      m.addEventListener('click', function() { var v=parseInt(inp.value)||1; if(v>1){inp.value=--v;self.qty=v;self.updatePrice();} });
      p.addEventListener('click', function() { var v=parseInt(inp.value)||1; inp.value=++v;self.qty=v;self.updatePrice(); });
      inp.addEventListener('change', function() { var v=parseInt(inp.value)||1; if(v<1)v=1; inp.value=v;self.qty=v;self.updatePrice(); });
    },

    getCalculatedPrice: function() {
      var total=this.basePrice, m=this.sel['measurement'];
      if (m&&m.sizePrice) total+=m.sizePrice;
      var keys=Object.keys(this.sel);
      for (var i=0;i<keys.length;i++) { if(keys[i]==='measurement')continue; var s=this.sel[keys[i]]; if(s&&s.price)total+=s.price; }
      return total;
    },

    updatePrice: function() {
      try {
        var total = this.getCalculatedPrice();
        var pe=document.getElementById('cw-dynamic-price');
        if (pe) pe.textContent='$'+total.toFixed(2);
        var te=document.getElementById('cw-total-price');
        if (te) { if(this.qty>1){te.textContent='Total: $'+(total*this.qty).toFixed(2);te.style.display='block';}else{te.style.display='none';} }
      } catch(e) {}
    },

    setDefaults: function() {
      try {
        document.querySelectorAll('.option-cards, .color-cards').forEach(function(c) {
          var def=c.querySelector('[data-default="true"]')||c.querySelector('.option-card, .color-card');
          if (def) def.click();
        });
        var fw=document.querySelector('.warranty-option'); if (fw) fw.click();
      } catch(e) {}
    },

    pendingProps: null,

    bindAddToCart: function() {
      var btn=document.getElementById('cw-add-to-cart'); if (!btn) return;
      var self=this;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        try {
          self.syncDOM();
          if (!self.validate()) return;
          var props = {}, keys=Object.keys(self.sel);
          for (var i=0;i<keys.length;i++) {
            var key=keys[i], s=self.sel[key]; if (!s) continue;
            if (key==='measurement') { props['Dimensions']=s.label; props['Width']=s.width+' '+(s.widthFraction||'0')+'"'; props['Height']=s.height+' '+(s.heightFraction||'0')+'"'; if(s.widthPrice>0) props['Width Surcharge']='+$'+s.widthPrice.toFixed(2); if(s.heightPrice>0) props['Height Surcharge']='+$'+s.heightPrice.toFixed(2); }
            else { var lbl=self.fmtLabel(key); props[lbl] = s.price>0 ? s.label+' (+$'+s.price.toFixed(2)+')' : s.label; }
          }
          var room=document.getElementById('cw-room-label');
          if (room&&room.value.trim()) props['Room Label']=room.value.trim();
          var calcPrice = self.getCalculatedPrice();
          props['_Calculated Price'] = '$' + calcPrice.toFixed(2);
          if (self.qty > 1) props['_Calculated Total'] = '$' + (calcPrice * self.qty).toFixed(2);
          self.pendingProps = props;
          self.showModal(props);
        } catch(e) { console.error('ATC error:', e); }
      });
    },

    submitCart: function() {
      var btn=document.getElementById('cw-add-to-cart'), confirmBtn=document.getElementById('cw-modal-confirm'), self=this;
      if (!this.pendingProps || !btn) return;
      this.hideModal();
      var vid=btn.dataset.variantId;
      btn.disabled=true; btn.textContent='Adding...';
      if (confirmBtn) { confirmBtn.disabled=true; confirmBtn.textContent='Processing...'; }
      fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:parseInt(vid), quantity:self.qty, properties:self.pendingProps}]})
      })
      .then(function(r) { if(!r.ok) throw new Error('Failed'); return r.json(); })
      .then(function() { btn.textContent='\u2713 Added!'; btn.style.background='#388e3c'; setTimeout(function(){window.location.href='/cart';},1000); })
      .catch(function(err) { console.error('Cart error:',err); btn.disabled=false; btn.textContent='Add to Cart'; if(confirmBtn){confirmBtn.disabled=false;confirmBtn.textContent='Confirm & Add to Cart';} alert('Failed to add to cart.'); });
    },

    syncDOM: function() {
      var self=this;
      try {
        document.querySelectorAll('.option-cards, .color-cards').forEach(function(c) {
          var mod=c.dataset.module, s=c.querySelector('.selected');
          if (s) self.sel[mod]={label:s.dataset.label, price:parseFloat(s.dataset.price)||0};
        });
        var sw=document.querySelector('.warranty-option.selected');
        if (sw) self.sel['warranty']={label:sw.dataset.label, price:parseFloat(sw.dataset.price)||0};
      } catch(e) {}
    },

    validate: function() {
      var valid=true, firstBad=null;
      try { var old=document.querySelectorAll('.field-error.dynamic-error'); for(var i=0;i<old.length;i++){if(old[i]&&old[i].parentNode)old[i].parentNode.removeChild(old[i]);} } catch(e){}
      try { var wI=document.getElementById('cw-width-int'); if(wI&&!wI.value){this.addError(wI,'Please select width');if(!firstBad)firstBad=wI;valid=false;} } catch(e){}
      try { var hI=document.getElementById('cw-height-int'); if(hI&&!hI.value){this.addError(hI,'Please select height');if(!firstBad)firstBad=hI;valid=false;} } catch(e){}
      try {
        var wC=document.getElementById('cw-width-int'),hC=document.getElementById('cw-height-int');
        var cb=document.getElementById('cw-dimension-confirm'),errD=document.getElementById('cw-dimension-error');
        if(cb&&wC&&wC.value&&hC&&hC.value&&!cb.checked){if(errD)errD.style.display='block';if(!firstBad)firstBad=errD||cb;valid=false;}
        else if(errD){errD.style.display='none';}
      } catch(e){}
      try {
        var mods=document.querySelectorAll('.customizer-module[data-required="true"]');
        for(var j=0;j<mods.length;j++){var mod=mods[j];if(!mod)continue;var name=mod.dataset.moduleName;if(name==='measurement')continue;
        var con=mod.querySelector('.option-cards, .color-cards');if(con&&!con.querySelector('.selected')){this.addError(con,'Please select '+(name||'').replace(/_/g,' '));if(!firstBad)firstBad=con;valid=false;}}
      } catch(e){}
      if(!valid&&firstBad){try{firstBad.scrollIntoView({behavior:'smooth',block:'center'});}catch(e){}}
      return valid;
    },

    addError: function(el,msg) {
      try { if(!el||!el.parentNode)return; var d=document.createElement('div'); d.className='field-error dynamic-error'; d.textContent=msg;
      d.style.cssText='display:block;color:#d32f2f;font-size:13px;margin-top:6px;font-weight:500;';
      el.parentNode.insertBefore(d,el.nextSibling); setTimeout(function(){try{if(d&&d.parentNode)d.parentNode.removeChild(d);}catch(e){}},5000); } catch(e){}
    },

    fmtLabel: function(k) { return k.replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase();}); }
  };

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){C.init();});}
  else{C.init();}
})();
